<template>
  <el-input placeholder="Buscar..." size="mini" v-model="input" class="input">
  <el-button slot="append"
             size="mini"
             :disabled="this.loadSearch"
             class="btn-append"
             @click="search">
    <i :class="icon"/>
  </el-button>
  </el-input>
</template>

<script>
import { apiRequest } from '@/backend/vue-axios/axios';

export default {
  props: {
  },
  name: 'ConfigSearch',
  data() {
    return {
      input: '',
      loadSearch: false,
    };
  },
  methods: {
    search() {
      if (this.input !== null && this.input !== '') {
        this.loadSearch = true;
        apiRequest(
          {
            module: 'planning',
            service: 'get_advanced_configs_planning',
            params: { search: this.input },
          },
        ).then((res) => {
          this.loadSearch = false;
          this.$emit('search', res.data);
        }).catch(() => {
          this.loadSearch = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Problemas al realizar la búsqueda',
          });
        });
      } else {
        this.$notify({
          type: 'warning',
          title: 'Ingrese un alias para buscar',
        });
      }
    },
  },
  computed: {
    icon() {
      return this.loadSearch ? 'el-icon-loading' : 'fas fa-search';
    },
  },
};
</script>

<style lang="scss" scoped>
  .input {
    float: right;
    width: calc(100% - 380px);
  }
  .btn-append {
    color: white !important;
    border: none !important;
    background-color: #AAD500 !important;
  }
</style>
